import { LocalShipping } from '@mui/icons-material';
import { Box, Typography, alpha } from '@mui/material';
import { QuoteFeeResponse } from '@trnsact/trnsact-shared-types';
import { formatCamelCaseToText } from 'formatters';
import { formatCurrency } from 'utils';
import { InfoListCard, InfoListRow } from './InfoListCard';

interface Props {
  fees: QuoteFeeResponse[];
  equipmentId: string;
}

export const EquipmentChargesCard = ({ fees, equipmentId }: Props) => {
  const equipmentFees = fees.filter(fee => fee.equipmentId === equipmentId);

  if (equipmentFees.length === 0) return null;

  const total = equipmentFees.reduce((sum, fee) => sum + (fee.price?.total ?? fee.price?.netPrice ?? 0), 0);

  const rows: InfoListRow[] = equipmentFees.map((fee, index) => ({
    key: `${fee.id ?? fee.type}-${index}`,
    label: fee.description || formatCamelCaseToText(fee.type),
    value: formatCurrency(fee.price?.total ?? fee.price?.netPrice, true),
  }));

  return (
    <InfoListCard
      icon={<LocalShipping color="primary" fontSize="small" />}
      title="Equipment Charges"
      count={equipmentFees.length}
      badge={
        <Box px={1} py={0.25} borderRadius={1} sx={{ bgcolor: theme => alpha(theme.palette.success.main, 0.1) }}>
          <Typography variant="body2" fontWeight={600} color="success.main">
            +{formatCurrency(total, true)}
          </Typography>
        </Box>
      }
      rows={rows}
    />
  );
};
